module.exports = __webpack_public_path__ + "img/newslist_m.fe846843.png";